import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLoaderData, useLocation } from 'react-router-dom';
import Title from '../../components/atoms/title';
import Header from '../../components/organisms/home/header';
import Sidebar from '../../components/organisms/home/sidebar';
import Breadcrumb from '../../components/organisms/home/breadcrumb';
import Text from '../../components/atoms/text';
import Dashboard from './dashboard';
import { HomeLoaderData } from '../../types/homeLoaderData';

const Home = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const { user, accountId } = useLoaderData() as HomeLoaderData;
	const [idClienteSelecionado, setIdClienteSelecionado] = useState(accountId);
	const idClienteDashboard = user.permissions.isSystemAdmin
		? idClienteSelecionado
		: accountId;
	const [isSidebarVisible, setIsSidebarVisible] = useState<boolean>(false);
	const [path, setPath] = useState<string>('home.title');

	useEffect(() => {
		const pathList = location.pathname.split('/');
		if (pathList[1] !== '') return setPath(`${pathList[1]}.title`);
		setPath('dashboard.title');
	}, [location]);

	return (
		<div className="relative background w-full min-h-screen px-0 lg:px-12 flex flex-col">
			<Title title={t(path)} />
			<Header
				onSidebarIconClick={() => setIsSidebarVisible(true)}
				idClienteSelecionado={idClienteDashboard}
				onClienteChange={setIdClienteSelecionado}
			/>
			<Sidebar
				isSidebarVisible={isSidebarVisible}
				setIsSidebarVisible={setIsSidebarVisible}
			/>
			<Breadcrumb />
			<main className="pb-3 px-3 lg:px-0 flex flex-col flex-grow gap-2">
				<Text className="text-primary" as="h2">
					{t(path)}
				</Text>
				{location.pathname === '/' ? (
					<Dashboard key={idClienteDashboard} idCliente={idClienteDashboard} />
				) : (
					<Outlet />
				)}
			</main>
		</div>
	);
};

export default Home;
